var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ColumnBaseSelectComponent } from '../base/columnbase-select.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
import { ConfigService } from '../../../service/config.service';
var Select2Component = /** @class */ (function (_super) {
    __extends(Select2Component, _super);
    function Select2Component(service, baseService, cdRef, config) {
        var _this = _super.call(this, service, baseService, cdRef) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.cdRef = cdRef;
        _this.config = config;
        _this.noInitSelect = false;
        return _this;
    }
    Select2Component.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    Select2Component.prototype.ngAfterViewInit = function () {
        this.element = this.select2Element.nativeElement;
        var params = this.col.params || {};
        var placeholder = params.placeholder || '';
        var width = params.formClass && params.formClass.width ? '100%' : '200px';
        $(this.element).select2({
            placeholder: placeholder,
            allowClear: !this.col.required,
            width: width,
        });
        this.setValue();
        var self = this;
        $(this.element).on('select2:select', function (e) {
            self.onChange($(this).val());
        });
        $(this.element).on('select2:unselect', function (e) {
            if (!self.col.required) {
                self.onChange('');
            }
            else {
                self.onChange(self.col.params.options[0].code);
            }
        });
    };
    Select2Component.prototype.ngOnChanges = function (changes) {
        if (changes.col && this.col) {
            this.setNoInitSelect();
        }
        if (!this.changeValFlg) {
            this.setValue();
        }
        _super.prototype.ngOnChanges.call(this, changes);
    };
    Select2Component.prototype.setNoInitSelect = function () {
        var noInitSelect = false;
        var key = (this.col.required ? 'required_no_init_select' : 'not_required_no_init_select');
        if (this.config.config[key]) {
            noInitSelect = (this.config.config[key] === 'true' ? true : false);
        }
        if (this.col.params && typeof this.col.params.noInitSelect !== 'undefined') {
            noInitSelect = this.col.params.noInitSelect;
        }
        this.noInitSelect = noInitSelect;
    };
    Select2Component.prototype.setValue = function () {
        if (typeof this.val === 'undefined' || this.val === null || this.val === '') {
            var options = (this.col.params && this.col.params.options ? this.col.params.options : []);
            if (options.length > 0 && this.col.required) {
                this.val = options[0].code;
            }
            else {
                this.val = '';
            }
            if (this.noInitSelect === true) {
                this.val = null;
            }
            this.onChange(this.val, false);
        }
        if (this.val !== null) {
            this.val = this.val.toString();
        }
        $(this.element).val(this.val).trigger('change');
    };
    Select2Component.prototype.onChange = function (e, changeFlg) {
        if (changeFlg === void 0) { changeFlg = true; }
        _super.prototype.onChange.call(this, e, changeFlg);
    };
    Select2Component.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-select2',
                    template: "\n        <select name=\"{{ colKey }}\" attr.name=\"{{ colKey }}\" [(ngModel)]=\"val\" [key]=\"key\" [col]=\"col\" columnDir #s2>\n            <option *ngIf=\"!col.required\" value=\"\"></option>\n            <option *ngFor=\"let option of col.params.options; trackBy: trackByOption\" [value]=\"option.code.toString()\">{{ option.display }}\n            </option>\n        </select>\n    ",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    Select2Component.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: ChangeDetectorRef },
        { type: ConfigService }
    ]; };
    Select2Component.propDecorators = {
        select2Element: [{ type: ViewChild, args: ['s2',] }]
    };
    return Select2Component;
}(ColumnBaseSelectComponent));
export { Select2Component };
//# sourceMappingURL=select2.component.js.map